<template>
    <div class="middle-message">
        <div class="image-honor">
            <img src="static/image/messageLogoNew.png"
                alt="">
        </div>
        <div class="title">{{welcomeTitle}}</div>
    </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
import utils from '../../../utils/comUtils.js';

export default {
  data() {
    return {
      welcomeTitle: '欢迎进入Hi荣耀小程序',
      loginType: '', //登录类型
      shareType: '',
      activityCode: '',
      activityUrl: '', //跳转链接
    };
  },
  computed: {},
  created() {
    const query = this.$route.query;
    this.activityUrl = encodeURIComponent(query.url);
    this.report();
    this.goWeChartApp();
  },
  mounted() {},
  methods: {
    // 调微信接口进入下个打开小程序的页面
    goWeChartApp() {
      Toast.loading({
        message: '跳转中...',
        forbidClick: true,
        duration: 0,
      });
      const params = new FormData();
      params.append('longUrl',decodeURIComponent(this.activityUrl));
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: '/h5/wechat/generateUrl',
        params: params,
        success: (res) => {
          Toast.clear();
          if (res.code === 200) {
            const data = res.result || '';
            if (data) {
              window.location.href = data;
            }
          } else {
            Toast.clear();
            Dialog.alert({
              message: res.message,
            });
          }
        },
        failure: () => {
          Toast.clear();
          Dialog.alert({
              message: '跳转失败，请刷新或者重新点击短信链接后重试。',
            });
        },
      });
    },
    // 埋码上报
    report() {
      const params = {
        actionCode: '900090001',
        actionName: '短信触达临时页面',
        content: {
          title: '短信触达临时页面',
          channel:  '' ,
          shareType:  '',
          activityCode: this.activityCode,
        },
      };
      utils.handleBatchReport(this, params);
    },
  },
};
</script>
<style scoped lang="scss">
.middle-message {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-image: url('../../../../static/image/messageBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .image-honor {
    width: 26.667vw;
    height: 26.667vw;
    img {
      width: 26.667vw;
      height: 26.667vw;
      position: absolute;
      left: 50%;
      top: 32%;
      transform: translate(-50%, -50%);
    }
  }
  .title {
    width: 100%;
    font-family: HONORSansBrand-Regular;
    font-size: 4.8vw;
    color: #000000;
    letter-spacing: 0;
    font-weight: 400;
    position: absolute;
    text-align: center;
    top: 41.5%;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/middleMessagePage/middleMessagePage.vue